/**
 * HUSL Rewards program numbers on the storefront.
 *
 * The rules (tiers, earn rates, point value, birthday, referral) are edited in Django admin
 * and served by GET /api/v3/rewards/program/. Any element with data-rw-text="<key>" gets the
 * live value; its own text is the fallback if the API is unreachable. Elements with
 * data-rw-if="<key>" are hidden when that value is zero (e.g. no birthday minimum spend).
 *
 * Keys: point-cents, value-per-100, redeem-min, welcome-points, stylist-rate, stylist-rate-num,
 * max-rate-num, birthday-amount, birthday-min, birthday-lock-days, referral-amount, referral-min,
 * tier-<glow|radiance|luminous>-name|rate|rate-num|min|expiry
 */
(function (global) {
  var CACHE_KEY = 'husl_rw_program_v1';
  var CACHE_MS = 10 * 60 * 1000;

  function apiBase() {
    return global.HuslEnv && global.HuslEnv.apiBase ? global.HuslEnv.apiBase() : 'https://api.huslbeauty.com';
  }

  function trim(n) {
    return String(Math.round(Number(n) * 100) / 100);
  }

  function dollars(n) {
    var v = Number(n || 0);
    return '$' + (v % 1 === 0 ? String(v) : v.toFixed(2));
  }

  function values(program) {
    var out = {
      'point-cents': trim(program.point_value * 100) + 'c',
      'value-per-100': dollars(Math.round(program.point_value * 10000) / 100),
      'redeem-min': String(program.redeem_min_points),
      'welcome-points': String(program.welcome_points),
      'stylist-rate': trim(program.stylist_earn_rate) + 'x',
      'stylist-rate-num': trim(program.stylist_earn_rate),
      'birthday-amount': dollars(program.birthday.amount),
      'birthday-min': program.birthday.min_spend ? dollars(program.birthday.min_spend) : '',
      'birthday-lock-days': String(program.birthday.lock_days),
      'referral-amount': dollars(program.referral.reward_amount),
      'referral-min': program.referral.min_spend ? dollars(program.referral.min_spend) : ''
    };
    var maxRate = Number(program.stylist_earn_rate);
    (program.tiers || []).forEach(function (tier) {
      var key = 'tier-' + tier.key + '-';
      out[key + 'name'] = tier.name;
      out[key + 'rate'] = trim(tier.earn_rate) + 'x';
      out[key + 'rate-num'] = trim(tier.earn_rate);
      out[key + 'min'] = dollars(tier.min_spend);
      out[key + 'expiry'] = String(tier.voucher_expiry_days);
      maxRate = Math.max(maxRate, Number(tier.earn_rate));
    });
    out['max-rate-num'] = trim(maxRate);
    return out;
  }

  function apply(program, root) {
    var map = values(program);
    var scope = root || document;
    scope.querySelectorAll('[data-rw-text]').forEach(function (el) {
      var value = map[el.getAttribute('data-rw-text')];
      if (value !== undefined && value !== '') el.textContent = value;
    });
    scope.querySelectorAll('[data-rw-if]').forEach(function (el) {
      el.hidden = !map[el.getAttribute('data-rw-if')];
    });
    return map;
  }

  function readCache() {
    try {
      var cached = JSON.parse(global.sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.at < CACHE_MS) return cached.program;
    } catch (e) { /* storage blocked: fetch instead */ }
    return null;
  }

  function writeCache(program) {
    try {
      global.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), program: program }));
    } catch (e) { /* ignore */ }
  }

  var pending = null;
  function load() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);
    if (!pending) {
      pending = fetch(apiBase() + '/api/v3/rewards/program/', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('program ' + r.status); return r.json(); })
        .then(function (program) { writeCache(program); return program; })
        .catch(function () { pending = null; return null; });
    }
    return pending;
  }

  global.HUSLRewardsProgram = { load: load, apply: apply, values: values };

  function run() {
    if (!document.querySelector('[data-rw-text],[data-rw-if]')) return;
    load().then(function (program) { if (program) apply(program); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})(typeof window !== 'undefined' ? window : this);
